<template>
    <div>
        <b-form-group
            label="Fields"
            label-for="fields"
            :label-cols="3"
            :horizontal="false">
            <b-button variant="primary" @click="editField = true"> Edit </b-button>
        </b-form-group>

        <b-modal title="Fields" v-model="editField" hide-footer>
            <Fields v-model="constraints.table.fields"/>
        </b-modal>
    </div>
</template>
<script>
import _ from 'lodash'

export default {
    components: {
        Fields: () => import("../../../base/Settings/Fields")
    },
    props: {
        value: {
            type: Object | String
        }
    },
    data: function() {
        return {
            editField: false
        }
    },
    computed: {
        constraints() {
            let constr = this.value

            if (constr.table.fields === null) {
                constr.table.fields = [];
            }

            return constr
        }
    },
    methods: {
        save() {
            this.$emit('input', this.constraints)
        },

        saveField() {
            this.constraints.table.fields.push(this.field.data);
            this.field.show = false;
            this.field.data = {
                required: false,
                label: '',
                key: '',
                sortable: false
            }
        },

        fieldError(error) {
        let found = this.errors.find((i, e) => {
            return i.field == error.field
        })

        if (found === undefined) {
            this.errors.push(error)
        } else {
            this.errors.map(e => {
                if (found.field == e.field)
                    e.error = error.error
            })
        }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        validateFields() {
            return this.constraints.table.fields.find(f => {
                return this.field.field.key == f.key || this.field.field.label == f.label
            })
        }
    }
    
}
</script>